import { type } from "@amcharts/amcharts5";

export default {
    init() {
        this.lotsCarrousel();
        this.lotsNavigation();
        this.watchedBeforeSlider();
        this.lotBidLiked();
        this.priceAndVatCounter();
        this.lotsActions();
    },


    lotsCarrousel(){
        let slickSettings = {
            slidesToShow: 1,
            dots: false,
            infinite: false,
            arrows: true,
            speed: 300,
            autoplay: false,
            slidesToScroll: 1,
            fade: true,
            variableHeight: true,
        };

        let slider = $('.product-full--gallery--main-slider');

        slider.slick(slickSettings);
        let selector = $('.product-full--gallery--main-slider .slick-slide a');

        selector.fancybox({
            loop: false,
            infobar: false,
            hash: false,
            backFocus: false,
            animationEffect: "fade",
            padding: 0,
            thumbs: {
                autoStart: false
            },
            buttons: [
                'slideShow',
                'fullScreen',
                'close'
            ]
        });
    },

    lotsNavigation() {
        let navItems = $('.product-full--gallery--navigation .item');
        let galleryItems = $('.product-full--gallery--main-slider .slick-slide');
        let fancyboxItems = $('.product-full--gallery--main-slider .slick-slide a');
        let slider = $('.product-full--gallery--main-slider');

        navItems.eq(0).addClass('active');

        // counter
        if (galleryItems.length > navItems.length) {
            $('.product-full--gallery--navigation .item.counter span').html( '+' + (galleryItems.length -11).toString());
        } else {
            $('.product-full--gallery--navigation .item.counter').remove();
        }

        // navigation click
        navItems.on('click', function () {
            let thisIndex = $(this).index();

            fancyboxItems.eq(thisIndex).trigger('click');
            navItems.removeClass('active');
            navItems.eq(thisIndex).addClass('active');
            slider.slick('slickGoTo', thisIndex);
        });

        // slider change
        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            navItems.removeClass('active');
            navItems.eq(nextSlide).addClass('active');

            if (nextSlide + 1 === 12) {
                fancyboxItems.eq(nextSlide).trigger('click');
            }
        });
    },

    watchedBeforeSlider(){
        $('.watched-before--slider').slick({
            infinite: true,
            slidesToShow: 5,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]

        });
    },

    lotBidLiked(){
        $('.product-card--favorite icon').on('click', function(){
            $(this).parent().toggleClass('active');
        })
    },

    priceAndVatCounter(){
        let bidInputObj = $('.bid-input-socketed');
        let currency = $('.product-price-responsive').attr('currency');
        let vat = $('.vat-price-responsive').attr('vat');
        let servicesTotal = parseFloat($('.total-price-responsive').attr('services-price'));
        let vatTotal = parseFloat($('.total-vat-responsive').attr('services-vat'));
        
        let productPrice = parseFloat(bidInputObj.val());
        if(isNaN(productPrice)){
            productPrice = parseFloat($('.product-price-responsive').attr('buynowPrice'));
        }
        productPrice = parseFloat(productPrice.toFixed(2))
        $('.product-price-responsive').html(productPrice + ' ' + currency);
        let vatPrice = 0;
        if(vat !== undefined){
            vatPrice = productPrice * vat / 100;
            vatPrice = parseFloat(vatPrice.toFixed(2))
            $('.vat-price-responsive').html(vatPrice + ' ' + currency);
            
        }
        let totalVat = vatTotal + vatPrice;
        totalVat = parseFloat(totalVat.toFixed(2));
        $('.total-vat-responsive').html(totalVat + ' ' + currency);
        let totalPrice = servicesTotal + vatPrice + productPrice;
        totalPrice = parseFloat(totalPrice.toFixed(2));
        $('.total-price-responsive').html(totalPrice + ' ' + currency);
        
        $(bidInputObj).on('input', function(){
            let productPrice = parseFloat(bidInputObj.val());
            productPrice = parseFloat(productPrice.toFixed(2))
            $('.product-price-responsive').html(productPrice + ' ' + currency);
            let vatPrice = 0;
            if(vat !== undefined){
                vatPrice = productPrice * vat / 100;
                vatPrice = parseFloat(vatPrice.toFixed(2))
                $('.vat-price-responsive').html(vatPrice + ' ' + currency);
            }
            let totalVat = vatTotal + vatPrice;
            totalVat = parseFloat(totalVat.toFixed(2));
            $('.total-vat-responsive').html(totalVat + ' ' + currency);
            let totalPrice = servicesTotal + vatPrice + productPrice;
            totalPrice = parseFloat(totalPrice.toFixed(2));
            $('.total-price-responsive').html(totalPrice + ' ' + currency);
        });
    },


    lotsActions(){
        if($('.auction-bidding-wrap').hasClass('losing')){
            setTimeout(function(){
                $('.auction-bidding-wrap--header .title').css('color', '#363c53');
                $('.bid-info-extra').css('color', '#778795');
                $('.bid-info-extra').css('background-color', '#F5F7F7');
            }, 3000); // 3 seconds in milliseconds
        }
    }
}